const frameMaterialOptions = [
    'Kunststoff',
    'Zink-Druckguss',
    'Edelstahl',
    'Aluminium'
];

export default frameMaterialOptions;
